import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../../services/api';
import apiAsyncThunkCreator from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { IFetchProjectPayload, ISetProjectsResponse } from './projects.interfaces';
import { Regions } from '../../../components/common/domain/accountRegions';

// TODO: Remove this function when Features.BillingUserFacing is approved in staging and prod
export const fetchProjects: AsyncThunk<
  ISetProjectsResponse,
  IFetchProjectPayload,
  ThunkAPI
> = createAsyncThunk(
  'accounts/fetchProjects',
  (data: IFetchProjectPayload, thunk) => {
    const { region } = data;
    let serviceUrl;
    switch (region) {
    case Regions.Australia: {
      serviceUrl = SERVICES.PROJECTS_SERVICE_V2_AU;
      break;
    }
    case Regions.EuropeUnion: {
      serviceUrl = SERVICES.PROJECTS_SERVICE_V2_EUROPE;
      break;
    }
    default: {
      serviceUrl = SERVICES.PROJECTS_SERVICE_V2_GLOBAL;
      break;
    }}
    delete data.region;

    return apiAsyncThunkCreator<ISetProjectsResponse, IFetchProjectPayload>({
      endpoint: '/stats/admins/filter-by',
      microservice: serviceUrl,
      authenticated: true,
      method: HttpMethods.Post
    })(data, thunk);
  }
);

export const fetchQuestionPackages: AsyncThunk<
  string[],
  { region: string },
  ThunkAPI
> = createAsyncThunk(
  'accounts/fetchQuestionPackages',
  (data, thunk) => {
    const { region } = data;
    let serviceUrl;
    switch (region) {
    case Regions.Australia: {
      serviceUrl = SERVICES.PROJECTS_SERVICE_V2_AU;
      break;
    }
    case Regions.EuropeUnion: {
      serviceUrl = SERVICES.PROJECTS_SERVICE_V2_EUROPE;
      break;
    }
    default: {
      serviceUrl = SERVICES.PROJECTS_SERVICE_V2_GLOBAL;
      break;
    }}

    return apiAsyncThunkCreator<string[], void>({
      endpoint: '/questionsLibrary/packages',
      microservice: serviceUrl,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);
